import React, { useEffect, useState } from "react";
import "../EnrolledCourses/EnrolledCourses.scss";
import BackArrow from "../../assets/images/vactor/back-arrow\.svg";
import BookIcon from "../../assets/images/vactor/sm-balck-book.svg";
import WatchIcon from "../../assets/images/vactor/sm-watch.svg";
import StarIcon from "../../assets/images/vactor/line-star-icon.svg";
import RoundCheckIcon from "../../assets/images/vactor/green-check-round.svg";
import BlueRoundCheckIcon from "../../assets/images/vactor/blue-round-check.svg";
import DisabledRoundCheckIcon from "../../assets/images/vactor/disabled-check.svg";
import GraphIcon from "../../assets/images/vactor/graph-green.svg";
import LampIcon from "../../assets/images/vactor/lamp-yellow\.svg";
import Ai_Icon from "../../assets/images/vactor/Ai-icon.svg";
import SelectRightIcon from "../../assets/images/vactor/sm-select-right.svg";
import CloseIcon from "../../assets/images/vactor/close-line.svg";
import { LightButton, PrimaryButton } from "../AllButtons/AllButtons";
import MathRenderer from "../CommonElements/MathRenderer";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  LinearProgress,
  linearProgressClasses,
  Radio,
  RadioGroup,
  styled,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../Store/store";
import { LatexMessage } from "../ChatBox/ChatBox";
import { useNavigate, useLocation } from "react-router-dom";
import useMentorTips from "../../hooks/useMentorTips";
import { getUserDetails } from "../../Services/profile.service";
import { getTaskStatus } from "../../Services/course.service";
import { reviewAnswer } from "../../Slice/courseSlice";

const EnrolledCoursesIntermediate = () => {
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[200],
      ...theme.applyStyles("dark", {
        backgroundColor: theme.palette.grey[800],
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: "#4F46E5",
      ...theme.applyStyles("dark", {
        backgroundColor: "#4F46E5",
      }),
    },
  }));
  const course = useAppSelector(state => state.course.intermediateCourse);
  const reviewAnswerLocal = useAppSelector(state => state.course.reviewAnswer);
  const testDetails = useAppSelector(state => state.course.testDetails?.results);
  const lessons = course?.course_content[0].sub_lessons;
  const navigate = useNavigate();
  const location = useLocation();
  const [continueLearning, setContinueLearning] = useState(false);
  const [lessonIndex, setLessonIndex] = useState(Number);
  const [showLessonContent, setShowLessonContent] = useState(false);
  const [giveTest, setGiveTest] = useState(false);
  const mentor_tips = course?.mentor_tips || []; 
  const socketTips = useMentorTips();
  const finalTips = socketTips.length > 0 ? socketTips : mentor_tips;
  const handleContinueLearning = () => {
    setContinueLearning(true);
  }
  const dispatch = useAppDispatch();
  const calculateProgress = () => {
    if (!lessons || lessons.length === 0) return 0;
    const completedCount = lessons.filter((lesson:any) => lesson.lesson_status === "completed").length;
    return Math.round((completedCount / lessons.length) * 100);
  };
  
  
  const completedLessons = lessons?.filter((lesson:any) => lesson.lesson_status === "completed") || [];
  const notStartedLessons = lessons?.filter((lesson:any) => lesson.lesson_status === "not_started") || [];
  
  const hasInProgressLessons = notStartedLessons.length > 0;
  const inProgressLessonCount = hasInProgressLessons ? 1 : 0;
  const remainingLessonsCount = Math.max(0, notStartedLessons.length - (hasInProgressLessons ? 1 : 0));

  useEffect(() => {
    dispatch(getUserDetails(localStorage.getItem('id')));
    if (!course) {
      if(localStorage.getItem('intermediatetaskid')){
      dispatch(getTaskStatus(localStorage.getItem('intermediatetaskid')));}
    }
    if(localStorage.getItem('intermediatenavigate')==='true'){
      localStorage.setItem('intermediatenavigate','false');
    }
  }, [])

  useEffect(() => {
    if (location.state?.continueLearning) {
      setContinueLearning(true);
    } else {
      setContinueLearning(false);
    }
  }, [location.state]);

  useEffect(() => {
    if (showLessonContent) {
      window.scrollTo(0, 0);
    }
  }, [showLessonContent]);

  useEffect(() => {
    if (!showLessonContent && !giveTest && !reviewAnswerLocal) {
      if(localStorage.getItem('intermediatetaskid')){
      dispatch(getTaskStatus(localStorage.getItem('intermediatetaskid')));}
    }
  }, [showLessonContent, giveTest, reviewAnswerLocal]);

  let title = course?.course_name;
  let description = "";
  if (course?.course_name.includes(":")) {              
    const parts = course.course_name.split(":");
      title = parts[0];     
  } 
  if(course?.course_description.includes(":")){
    const parts1 = course.course_description.split(":");
     description = parts1[1]?.trim() || "";
  }  else {             
    const topic = course?.course_name.replace(/.*on /, "");
    if (course?.course_level === 'beginner') {
      description = `Master the basics of ${topic} with interactive exercises.`;
    } else if (course?.course_level === 'intermediate') {
      description = `Learn ${topic} through practical problems and examples.`;
    } else if (course?.course_level === 'advanced') {
      description = `Deep dive into ${topic} with expert-level guidance.`;
    }
  }

  return (
    <>
      <div className="courses-wrapper">
        {!showLessonContent && !giveTest && !reviewAnswerLocal && (
          <div className="courses-header-wrapper">
            <div className="courses-header-title">
              <img
                src={BackArrow}
                style={{ "cursor": "pointer" }}
                alt=""
                onClick={() => { navigate('/dashboard/course_list') }}
              />
              <span>Enrolled courses</span>
            </div>
            <p className="courses-header-dsc">
              Based on your diagnostic results, these courses are tailored to
              boost your skills!
            </p>
          </div>
        )}
        <div className="courses-content-body-wrapper">
          {/* for enrolled corses card */}
          {!continueLearning && !giveTest && !reviewAnswerLocal && (
            <div className="courses-card ">
              <div className="courses-card-head">
                <div className="course-list-badge intermediate-badge">{course?.course_type ? course.course_type.charAt(0).toUpperCase() + course.course_type.slice(1) : "Intermediate"}</div>
                {/* <div>
                  <img src={TagIcon} alt="" />
                </div> */}
              </div>
              <div className="courses-card-body">
                <h4 className="courses-card-title">{title}</h4>
                <p className="courses-card-dsc">
                  {description}
                </p>
                <div className="coreses-progress">
                  <div className="coreses-progress-tracker">
                    <div className="coreses-progress-value">
                      <h3>{calculateProgress()}%</h3>{" "}
                      <span className="progress-label">Courses progress</span>
                    </div>
                    <div className="time-duration-label">
                      <span>
                        {" "}
                        <img src={WatchIcon} alt="" /> {course?.estimated_time_left_label}
                      </span>
                      <span>
                        {" "}
                        <img src={BookIcon} alt="" /> {notStartedLessons.length} lessons remaining{" "}
                      </span>
                    </div>
                  </div>
                  <div className="overall-score-level-progress">
                    <BorderLinearProgress variant="determinate" value={calculateProgress()} />
                  </div>
                </div>
                <div className="coreses-card-action">
                  <PrimaryButton
                    onClick={() => {
                      handleContinueLearning();
                    }}
                  >
                    Continue Learning
                  </PrimaryButton>
                </div>
              </div>
            </div>
          )}

          {/* for Ongoing Exercise card */}
          {continueLearning && !showLessonContent && !reviewAnswerLocal && (
            <div className="courses-card">
              <div className="courses-card-body">
                <div className="coreses-progress">
                  <div className="coreses-progress-tracker">
                    <div className="coreses-progress-value">
                      <h3>{calculateProgress()}%</h3>{" "}
                      <span className="progress-label">Course progress</span>
                    </div>
                    <div className="time-duration-label">
                      <span>
                        {" "}
                        <img src={WatchIcon} alt="" /> {course?.estimated_time_left_label}
                      </span>
                      <span>
                        {" "}
                        <img src={BookIcon} alt="" /> {notStartedLessons.length} lessons remaining{" "}
                      </span>
                    </div>
                  </div>
                  <div className="overall-score-level-progress">
                    <BorderLinearProgress variant="determinate" value={calculateProgress()} />
                  </div>
                </div>
              </div>
            </div>
          )}

          {continueLearning && !showLessonContent && !reviewAnswerLocal && (
            <div className="row gy-4">
              <div className="col-md-7 col-lg-8">
                <div className="courses-card course-content-card">
                  <div className="course-content-card-title">
                    <span>Course Content</span>
                  </div>
                  <div className="course-content-card-subtitle">
                    <span className="card-subtitle">Completed Lessons</span>
                    <span className="subtitle-notes">
                      {completedLessons.length} of {lessons?.length} completed
                    </span>
                  </div>

                  <div className="completed-leasson-list">
                    {completedLessons.map((lesson:any, index:any) => (
                      <div
                        className="leasson-list-items"
                        key={index}
                        onClick={() => {
                          const actualIndex = lessons.indexOf(lesson);
                          setLessonIndex(actualIndex);
                          setShowLessonContent(true);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="leasson-items-label">
                          <img src={RoundCheckIcon} alt="" />
                          {lesson.sub_lesson_title}
                        </div>
                        <div className="leasson-items-duration">{lesson?.estimated_duration_label }</div>
                      </div>
                    ))}
                  </div>

                  {/* Only show In Progress section if there are lessons not started */}
                  {hasInProgressLessons && (
                    <>
                      <div className="course-content-card-subtitle">
                        <span className="card-subtitle">In Progress</span>
                        <span className="subtitle-notes">{inProgressLessonCount} lesson in progress</span>
                      </div>
                      <div className="inprogress-lesson-list">
                        {notStartedLessons.slice(0, 1).map((lesson:any) => {
                          const actualIndex = lessons.indexOf(lesson);
                          return ( 
                            <div className="inprogres-lesson-block" key={lesson.sub_lesson_id}>
                              <div className="inprogres-lesson-label-head">
                                <div className="inprogres-lesson-label">
                                  <img src={BlueRoundCheckIcon} alt="" />
                                  <span>{lesson.sub_lesson_title}</span>
                                </div>
                                <div className="inprogres-progress-bar">
                                  <PrimaryButton
                                    onClick={() => {
                                      setLessonIndex(actualIndex);
                                      setShowLessonContent(true);
                                    }}
                                  >
                                    Resume Lesson
                                  </PrimaryButton>
                                  <div className="inprogres-lesson-timeduration">{lesson?.estimated_duration_label}</div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}

                  {/* Only show Remaining Lessons section if there are more than 1 not started lessons */}
                  {remainingLessonsCount > 0 && (
                    <div className="completed-leasson-list disabled-list">
                      <div className="course-content-card-subtitle">
                        <span className="card-subtitle">Remaining Lessons</span>
                        <span className="subtitle-notes">
                          {remainingLessonsCount} lessons remaining
                        </span>
                      </div>
                      {notStartedLessons.slice(1).map((lesson:any, index:any) => (
                        <div className="leasson-list-items" key={index}>
                          <div className="leasson-items-label">
                            <img src={DisabledRoundCheckIcon} alt="" />
                            {lesson.sub_lesson_title}
                          </div>
                          <div className="leasson-items-duration">{lesson?.estimated_duration_label}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-5 col-lg-4">
                <div className="courses-card-group">
                  <div className="courses-card course-content-card mentor-tips">
                    <div className="course-content-card-title">
                      <img src={Ai_Icon} alt="" />
                      <span>AI Mentor Tips</span>
                    </div>
                    <div className="mentor-tips-dsc">
                      Based on your progress, consider focusing on:
                    </div>
                      <div className="">
                        {finalTips?.length > 0 ? (
                          <ul className="mentor-tips-list">
                            {finalTips.map((tip: any, idx: number) => (
                              <li className="mentor-tips-dsc" key={idx}>
                                {typeof tip === "string"
                                  ? tip
                                  : tip.message || tip.tip || tip.text}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <ul className="mentor-tips-list">
                            <li className="mentor-tips-dsc">
                              Review the complex numbers chapter before moving to advanced applications
                            </li>
                            <li className="mentor-tips-dsc">
                              You're making great progress! Keep up the momentum
                            </li>
                          </ul>
                        )}
                      </div>
                  </div>
                  {/* <div className="courses-card course-content-card quick-status">
                    <div className="course-content-card-title">
                      <span>Quick Stats</span>
                    </div>

                    <div className="quick-status-list">
                      <div className="quick-status-list-items">
                        <div className="quick-status-items-label">
                          Study Streak
                        </div>
                        <div className="quick-status-items-value status-yellow">
                          <img src={FireIcon} alt="" /> <span>5 days</span>
                        </div>
                      </div>
                      <div className="quick-status-list-items">
                        <div className="quick-status-items-label">Time Spent</div>
                        <div className="quick-status-items-value status-blue">
                          <img src={BlueWatchIcon} alt="" />{" "}
                          <span>12.5 hours</span>
                        </div>
                      </div>
                      <div className="quick-status-list-items">
                        <div className="quick-status-items-label">
                          Practice Score
                        </div>
                        <div className="quick-status-items-value status-green">
                          <img src={NetworkIcon} alt="" /> <span>85%</span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          )}
          {/* End Ongoing Exercise card */}

          {/* for Ongoing Exercise Learn Leasson card */}
          {showLessonContent && !reviewAnswerLocal && (
            <div className="courses-card">
              <div className="courses-header-wrapper">
                <div className="courses-header-title">
                  <img
                    src={BackArrow}
                    alt=""
                    style={{ "cursor": "pointer" }}
                    onClick={() => { setShowLessonContent(false) }}
                  />
                  <span>{lessons[lessonIndex].sub_lesson_title}</span>
                </div>
              </div>
              <div className="courses-card-head">
                <div className="time-duration-label">
                  <span>
                    {" "}
                    <img src={WatchIcon} alt="" /> {lessons[lessonIndex]?.estimated_duration_label }
                  </span>
                  <span>
                    {" "}
                    <img src={StarIcon} style={{ width: "16px" }} alt="" />{" "}
                    {course?.course_type ? course.course_type.charAt(0).toUpperCase() + course.course_type.slice(1) : "Intermediate"}
                  </span>
                </div>
              </div>
              <div className="courses-card-body mt-4 learn-leasson-body">
                <p className="courses-card-dsc">
                  <MathRenderer text={lessons[lessonIndex].lesson_teaching} />
                </p>
              </div>
              <div className="coreses-card-action learn-leasson-action">
                <LightButton
                  className="prev-button"
                  onClick={() => {
                    if (lessonIndex === 0) {
                      setShowLessonContent(false);
                    } else {
                      setLessonIndex(lessonIndex - 1);
                      window.scrollTo(0, 0);
                    }
                  }}
                >
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="17"
                    viewBox="0 0 14 17"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_2582_56052)">
                      <path
                        d="M0.293945 7.79414C-0.0966797 8.18477 -0.0966797 8.81914 0.293945 9.20977L5.29395 14.2098C5.68457 14.6004 6.31895 14.6004 6.70957 14.2098C7.1002 13.8191 7.1002 13.1848 6.70957 12.7941L3.4127 9.50039H13.0002C13.5533 9.50039 14.0002 9.05352 14.0002 8.50039C14.0002 7.94727 13.5533 7.50039 13.0002 7.50039H3.41582L6.70645 4.20664C7.09707 3.81602 7.09707 3.18164 6.70645 2.79102C6.31582 2.40039 5.68145 2.40039 5.29082 2.79102L0.29082 7.79102L0.293945 7.79414Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2582_56052">
                        <path d="M0 0.5H14V16.5H0V0.5Z" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                  {lessonIndex === 0 ? " Course Content" : "Previous Lesson"}
                </LightButton>
                <PrimaryButton
                  className="next-button"
                  onClick={() => {
                    setContinueLearning(false);
                    setShowLessonContent(false);
                    setGiveTest(true);
                    navigate('/course_test', {
                      state: {
                        lessonIndex: `${lessonIndex}`,
                        intermediateCourse: 'true'
                      },
                    })
                  }}
                >
                  Give Test{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                  >
                    <path
                      d="M13.7063 7.20664C14.0969 6.81602 14.0969 6.18164 13.7063 5.79102L8.70625 0.791016C8.31563 0.400391 7.68125 0.400391 7.29063 0.791016C6.9 1.18164 6.9 1.81602 7.29063 2.20664L10.5875 5.50039H1C0.446875 5.50039 0 5.94727 0 6.50039C0 7.05352 0.446875 7.50039 1 7.50039H10.5844L7.29375 10.7941C6.90312 11.1848 6.90312 11.8191 7.29375 12.2098C7.68437 12.6004 8.31875 12.6004 8.70938 12.2098L13.7094 7.20977L13.7063 7.20664Z"
                      fill="white"
                    />
                  </svg>
                </PrimaryButton>
              </div>
            </div>
          )}

          {/* Review and Answer card  */}
          {reviewAnswerLocal && (
            <div className="courses-card review-answer-card">
              <div className="courses-header-wrapper">
                <div className="courses-header-title">
                  <img
                    src={BackArrow}
                    style={{ "cursor": "pointer" }}
                    alt=""
                    onClick={() => {
                      setShowLessonContent(false);
                      setContinueLearning(true);
                      dispatch(reviewAnswer())
                    }}
                  />
                  <span>Enrolled courses</span>
                </div>
              </div>
              <div className="question-answer-block">
                {Object.values(testDetails)?.map((question:any, index) => {
                  const selectedIndex = question.selected_option
                    ? question.selected_option.charCodeAt(0) - 65
                    : -1;

                  const correctIndex = question.correct_option
                    ? question.correct_option.charCodeAt(0) - 65
                    : -1;

                  return (
                    <React.Fragment key={question.question_id}>
                      <div className="stepper-form-block">
                        <FormControl>
                          <FormLabel className="stepper-question" id={`question-label-${index + 1}`}>
                            <MathRenderer text={`${index + 1}. ${question.question}`} />
                          </FormLabel>
                          <RadioGroup
                            aria-labelledby={`question-label-${index + 1}`}
                            name="radio-buttons-group"
                          >
                            {question.options.map((optionText:any, optionIndex:any) => {
                              const isSelected = optionIndex === selectedIndex;
                              const isCorrect = optionIndex === correctIndex;

                              return (
                                <FormControlLabel
                                  key={optionIndex}
                                  disabled
                                  value={String.fromCharCode(65 + optionIndex)}
                                  control={
                                    isSelected ? (
                                      <div className="selected-icon">
                                        <img
                                          src={isSelected && isCorrect ? SelectRightIcon : CloseIcon}
                                          alt={isSelected && isCorrect ? "Select Right Icon" : "Close Icon"}
                                        />
                                      </div>
                                    ) : (
                                      <Radio />
                                    )
                                  }
                                  className={
                                    isSelected
                                      ? isCorrect
                                        ? "selected-answer"
                                        : "wrong-answer"
                                      : ""
                                  }
                                  label={<MathRenderer text={optionText} />}
                                />
                              );
                            })}
                          </RadioGroup>
                        </FormControl>
                      </div>

                      <div className="question-answer-dsc-block">
                        <div className="question-answer-dsc-title">
                          {question.is_correct
                            ? "Why this is correct?"
                            : "Correct answer and Why?"}
                        </div>
                        <div className="answer-dsc">
                          <MathRenderer text={question.explanation} />
                          {!question.is_correct && (
                            <>
                              <br />- <MathRenderer text={question.options[correctIndex]} />
                            </>
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EnrolledCoursesIntermediate;